import { FormControl } from "@angular/forms";

export function cnpjValidator(control: FormControl) {
    const re = new RegExp(/^[A-Za-z0-9]{2}\.?[A-Za-z0-9]{3}\.?[A-Za-z0-9]{3}\/?[A-Za-z0-9]{4}\-?\d{2}$/);
    if (control.value != undefined && control.value != null && control.value != '' && !re.test(control.value))
        return {
            cnpj: true
        }
    return null;
}